import { render, staticRenderFns } from "./sysuser_list.vue?vue&type=template&id=32896570&scoped=true"
import script from "./sysuser_list.vue?vue&type=script&lang=js"
export * from "./sysuser_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32896570",
  null
  
)

export default component.exports